<template>
  <div class="animated fadeIn">
    <FiltersClientsProspectsLostRelaunch
      type="prospect"
      :commercials="commercials"
      :initial-filter="initialFilter"
      @applyFilters="applyFilters"
    />

    <Loader :is-visible="loading" />

    <div class="card">
      <div class="card-block">
        <Tabs v-model="activeTab" @input="changeTab">
          <Tab :header="withoutRelaunch">
            <ClientProspectLostRelaunch
              :clients="prospects.without_relaunch"
              :totalClients="totals.without_relaunch"
              :page="page"
              :limit="limit"
              @showComment="showCommentMethod"
              @changePage="changePage"
              @relaunchClient="handleRelaunch"
              @archiveClient="handleArchive"
              @changeSort="handleChangeSort"
            />
          </Tab>

          <Tab :header="relaunch1">
            <ClientProspectLostRelaunch
              :clients="prospects.relaunch_1"
              :totalClients="totals.relaunch_1"
              :page="page"
              :limit="limit"
              @showComment="showCommentMethod"
              @changePage="changePage"
              @relaunchClient="handleRelaunch"
              @archiveClient="handleArchive"
              @changeSort="handleChangeSort"
            />
          </Tab>

          <Tab :header="relaunch2">
            <ClientProspectLostRelaunch
              :clients="prospects.relaunch_2"
              :totalClients="totals.relaunch_2"
              :page="page"
              :limit="limit"
              @showComment="showCommentMethod"
              @changePage="changePage"
              @relaunchClient="handleRelaunch"
              @archiveClient="handleArchive"
              @changeSort="handleChangeSort"
            />
          </Tab>

          <Tab :header="relaunch3">
            <ClientProspectLostRelaunch
              :clients="prospects.relaunch_3"
              :totalClients="totals.relaunch_3"
              :page="page"
              :limit="limit"
              @showComment="showCommentMethod"
              @changePage="changePage"
              @archiveClient="handleArchive"
              @changeSort="handleChangeSort"
            />
          </Tab>
        </Tabs>
      </div>
    </div>

    <ClientNoteModal
      :show="modalUpdateNote.show"
      :client="modalUpdateNote.prospect"
      @close="modalUpdateNote.show = false"
    />
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import { mapState } from "vuex";
import moment from "moment";

import Loader from "@/components/utils/Loader";
import FiltersClientsProspectsLostRelaunch from "@/components/client/FiltersClientsProspectsLostRelaunch.vue";
import ClientProspectLostRelaunch from "@/components/client/ClientProspectLostRelaunch.vue";
import ClientNoteModal from "@/components/client/ClientNoteModal";

export default {
  components: {
    ClientNoteModal,
    ClientProspectLostRelaunch,
    FiltersClientsProspectsLostRelaunch,
    Loader,
    Tabs,
    Tab,
  },

  data() {
    return {
      loading: false,
      activeTab: 0,
      commercials: [],
      page: 1,
      offset: 0,
      limit: 15,
      countClients: true,
      prospects: {
        without_relaunch: null,
        relaunch_1: null,
        relaunch_2: null,
        relaunch_3: null,
      },
      initialFilter: {},
      searchForm: {
        concepts: [],
        commercials: [],
        lostSince: [],
        isB2B: false,
        name: null,
        sortOrder: null,
      },
      totals: {
        without_relaunch: 0,
        relaunch_1: 0,
        relaunch_2: 0,
        relaunch_3: 0,
      },
      modalUpdateNote: {
        show: false,
        prospect: null,
      },
    };
  },

  computed: {
    ...mapState({
      concepts: (state) => state.concepts,
      lostSinceOptions: (state) => state.lostSinceOptions,
      lostReasons: (state) => state.lostReasons,
    }),

    withoutRelaunch() {
      return `À relancer ${
        this.currentTab === "without_relaunch" &&
        !this.loading &&
        this.prospects.without_relaunch
          ? `(${this.totals.without_relaunch})`
          : ""
      }`;
    },

    relaunch1() {
      return `1ère relance ${
        this.currentTab === "relaunch_1" &&
        !this.loading &&
        this.prospects.relaunch_1
          ? `(${this.totals.relaunch_1})`
          : ""
      }`;
    },

    relaunch2() {
      return `2ème relance ${
        this.currentTab === "relaunch_2" &&
        !this.loading &&
        this.prospects.relaunch_2
          ? `(${this.totals.relaunch_2})`
          : ""
      }`;
    },

    relaunch3() {
      return `3ème relance ${
        this.currentTab === "relaunch_3" &&
        !this.loading &&
        this.prospects.relaunch_3
          ? `(${this.totals.relaunch_3})`
          : ""
      }`;
    },

    currentTab() {
      switch (this.activeTab) {
        case 0:
          return "without_relaunch";
        case 1:
          return "relaunch_1";
        case 2:
          return "relaunch_2";
        case 3:
          return "relaunch_3";
        default:
          return null;
      }
    },
  },

  async created() {
    await this.getCommercials();

    let activeTab =
      this.$route.query.tab ?? sessionStorage.getItem("prospectsRelaunchTab");

    if (activeTab && this.activeTab !== parseInt(activeTab)) {
      this.activeTab = parseInt(activeTab);
    }

    if (this.$route.query.page !== undefined) {
      this.page = parseInt(this.$route.query.page);
      this.offset = this.limit * this.page - this.limit;

      this.totals = Object.fromEntries(
        this.$route.query.totals.map(([key, value]) => [key, parseInt(value)]),
      );
      this.countClients = !!this.$route.query.count;

      let commercials = [];
      let concepts = [];

      if (this.$route.query.commercials) {
        commercials = Array.isArray(this.$route.query.commercials)
          ? this.$route.query.commercials
          : [this.$route.query.commercials];
      }

      if (this.$route.query.concepts) {
        concepts = Array.isArray(this.$route.query.concepts)
          ? this.$route.query.concepts
          : [this.$route.query.concepts];
      }

      this.searchForm = {
        concepts: concepts
          .map((c) => this.concepts.find((concept) => concept.name === c))
          .filter((c) => c),
        commercials: commercials
          .map((c) =>
            this.commercials.find((commercial) => commercial.value === c),
          )
          .filter((c) => c),
        isB2B: this.$route.query.isB2B || false,
        lostSince: this.$route.query.lostSince
          ? this.lostSinceOptions.find(
              (option) => option.value === this.$route.query.lostSince,
            )
          : null,
        name: this.$route.query.name || null,
        sortOrder: this.$route.query.sortOrder || "ascending",
      };

      this.initialFilter = { ...this.searchForm };

      this.getProspects(this.offset);
    } else {
      const currentCommercial = this.commercials.find(
        (c) => c.value === this.$store.state.user.email,
      );

      if (currentCommercial) {
        this.searchForm.commercials = [currentCommercial];
        this.form.commercial = currentCommercial;
      }

      this.initialFilter = { ...this.searchForm };
    }
  },

  methods: {
    async changeTab(index) {
      sessionStorage.setItem("prospectsRelaunchTab", index);

      this.countClients = true;

      this.$route.query.tab !== undefined && this.changePage(1);
    },

    async getCommercials() {
      try {
        this.isLoading = true;

        const { data } = await this.$api.get("/users/commercials/search");

        this.commercials = data.map((c) => ({
          value: c.email,
          label: c.commercial.pseudo,
          color: c.commercial.color,
        }));
      } catch (e) {
        this.commercials = [];
      } finally {
        this.isLoading = false;
      }
    },

    async getProspects() {
      try {
        this.loading = true;

        const { data } = await this.$api.get("/prospects/relaunch-lost", {
          params: {
            filters: {
              ...this.searchForm,
              commercials: this.searchForm.commercials.map((c) => c.value),
              concepts: this.searchForm.concepts.map((c) => c.name),
              lostSince: this.searchForm.lostSince?.value,
              currentTab: this.currentTab,
            },
            offset: this.offset,
            limit: this.limit,
            count: this.countClients,
            currentTotals: this.totals,
          },
        });

        this.totals = data.totals;

        const prospects = data.data.map((p) => {
          const lostReason = this.lostReasons.find(
            (reason) => reason.value === p.lostReason,
          );

          return {
            ...p,
            lostReason: lostReason?.label || null,
          };
        });

        switch (this.currentTab) {
          case "without_relaunch":
            this.prospects.without_relaunch = prospects;
            break;
          case "relaunch_1":
            this.prospects.relaunch_1 = prospects;
            break;
          case "relaunch_2":
            this.prospects.relaunch_2 = prospects;
            break;
          case "relaunch_3":
            this.prospects.relaunch_3 = prospects;
            break;
        }

        this.countClients = false;
      } catch (e) {
        this.$errorToast(e);
      } finally {
        this.loading = false;
      }
    },

    applyFilters(form) {
      this.searchForm = {
        ...this.searchForm,
        ...form,
      };

      this.countClients = true;

      this.changePage(1);
    },

    changePage(page) {
      this.$router.push({
        name: "prospects-lost-relaunch-list",
        query: {
          page,
          count: this.countClients,
          tab: this.activeTab,
          ...this.searchForm,
          concepts: this.searchForm.concepts.map((c) => c.name),
          commercials: this.searchForm.commercials.map((c) => c.value),
          isB2B: this.searchForm.isB2B,
          lostSince: this.searchForm.lostSince?.value,
          name: this.searchForm.name,
          totals: Object.entries(this.totals),
        },
      });
    },

    showCommentMethod(prospect) {
      this.modalUpdateNote = {
        ...this.modalUpdateNote,
        prospect,
        show: true,
      };
    },

    async handleRelaunch(prospect) {
      this.$confirm({
        message: `Êtes-vous sûr de vouloir relancer le prospect ${prospect.firstName} ${prospect.lastName} ?`,
        onConfirm: async () => {
          try {
            this.loading = true;

            const { data } = await this.$api.patch("/prospects/relaunch-lost", {
              email: prospect.email,
              relaunchNumber: prospect.relaunchNumber
                ? prospect.relaunchNumber + 1
                : 1,
              relaunchedAt: moment(),
            });

            this.prospects[this.currentTab] = this.prospects[
              this.currentTab
            ].filter((p) => p.id !== data.id);

            this.totals[this.currentTab]--;

            this.$successToast(`Le prospect a bien été relancé.`);
          } catch (e) {
            this.$errorToast(e.response?.data || e.message);
          } finally {
            this.loading = false;
          }
        },
      });
    },

    async handleArchive(prospect) {
      this.$confirm({
        message: `Êtes-vous sûr de vouloir archiver le prospect ${prospect.firstName} ${prospect.lastName} ?`,
        onConfirm: async () => {
          try {
            this.loading = true;

            const { data: id } = await this.$api.patch(
              "/prospects/relaunch-lost/archive",
              {
                email: prospect.email,
                archived: true,
              },
            );

            this.prospects[this.currentTab] = this.prospects[
              this.currentTab
            ].filter((p) => p.id !== id);

            this.totals[this.currentTab]--;

            this.$successToast(`Le prospect a bien été archivé.`);
          } catch (e) {
            this.$errorToast(e.response?.data || e.message);
          } finally {
            this.loading = false;
          }
        },
      });
    },

    handleChangeSort({ order }) {
      this.searchForm.sortOrder = order;
      this.countClients = true;

      this.changePage(1);
    },
  },
};
</script>
